export default "__VITE_ASSET__Bpd8siaS__"